import { CONDITION_LIMITS } from "./nativeConditions.mjs";

export function createNativeStyleResolver(session) {
  const cache = new Map();
  return {
    overrides(target, context) {
      const style = {};
      const matchedRuleIds = [];
      for (const rule of target?.conditions?.formatting || []) {
        if (rule.enabled === false) continue;
        if (session.evaluate(rule.when, context, { ruleId: rule.id, elementId: target.id, sourceIndex: context.sourceIndex }).value) {
          Object.assign(style, rule.style);
          matchedRuleIds.push(rule.id);
        }
      }
      return { styleOverrides: Object.freeze(style), styleRuleIds: Object.freeze(matchedRuleIds) };
    },
    resolve(base, ...orderedOverrides) {
      const style = Object.assign({}, base, ...orderedOverrides);
      const properties = Object.keys(style).sort();
      const key = JSON.stringify([properties, properties.map((property) => style[property])]);
      if (!cache.has(key)) {
        if (cache.size >= CONDITION_LIMITS.definitionNodes) cache.delete(cache.keys().next().value);
        cache.set(key, Object.freeze(style));
      }
      return cache.get(key);
    },
    get size() { return cache.size; },
  };
}
